module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_memebox_m.1228848e3896e296baf0606a0cbdbb26.png";